// extracted by mini-css-extract-plugin
export default {"container":"Subscribe_container__BWgMN"};